import { MONTH_ORDER, MONTH_YEAR_REGEX } from './constants'

export function getLastCompleteMonth(now: Date = new Date()): Date {
  return new Date(now.getFullYear(), now.getMonth() - 1, 1)
}

export function monthCodeToDate(monthCode: string): Date | null {
  const m = monthCode.match(MONTH_YEAR_REGEX)
  if (!m) return null
  const monthIndex = MONTH_ORDER.indexOf(m[1])
  const year = Number.parseInt(m[2], 10)
  if (monthIndex < 0 || Number.isNaN(year)) return null
  return new Date(year, monthIndex, 1)
}

export function sortMonthColumns(months: string[]): string[] {
  return [...months].sort((a, b) => {
    const da = monthCodeToDate(a)
    const db = monthCodeToDate(b)
    if (!da || !db) return 0
    return da.getTime() - db.getTime()
  })
}

const DUBLIN_TIMEZONE = 'Europe/Dublin'
const DUBLIN_DATE_KEY_FORMATTER = new Intl.DateTimeFormat('en-CA', {
  timeZone: DUBLIN_TIMEZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})
const DUBLIN_MONTH_YEAR_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  timeZone: DUBLIN_TIMEZONE,
  month: 'long',
  year: 'numeric',
})
const DUBLIN_SHORT_DATE_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  timeZone: DUBLIN_TIMEZONE,
  day: '2-digit',
  month: 'short',
})
const DUBLIN_LONG_DATE_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  timeZone: DUBLIN_TIMEZONE,
  day: '2-digit',
  month: 'long',
})
const DUBLIN_FULL_DATE_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  timeZone: DUBLIN_TIMEZONE,
  day: 'numeric',
  month: 'long',
  year: 'numeric',
})

/** Format a Date into a stable YYYY-MM-DD key in the Dublin timezone. */
export function formatDublinDateKey(date: Date): string {
  return DUBLIN_DATE_KEY_FORMATTER.format(date)
}

/** Format a Date into a "Month YYYY" label in the Dublin timezone. */
export function formatDublinMonthYear(date: Date): string {
  return DUBLIN_MONTH_YEAR_FORMATTER.format(date)
}

/** Format a Date into a short day + month label in the Dublin timezone. */
export function formatDublinShortDate(date: Date): string {
  return DUBLIN_SHORT_DATE_FORMATTER.format(date)
}

/** Format a Date into a long day + month label in the Dublin timezone. */
export function formatDublinLongDate(date: Date): string {
  return DUBLIN_LONG_DATE_FORMATTER.format(date)
}

/** Format a Date into a "Day Month Year" label in the Dublin timezone. */
export function formatDublinFullDate(date: Date): string {
  return DUBLIN_FULL_DATE_FORMATTER.format(date)
}

/** Parse a date string into a Date, defaulting to UTC midnight for date-only values. */
export function parseEventDate(value?: string | null): Date | null {
  if (!value) return null
  if (value.includes('T')) return new Date(value)
  return new Date(`${value}T00:00:00Z`)
}
